import { render, staticRenderFns } from "./SurveyDownload.vue?vue&type=template&id=5913dd6e&scoped=true"
import script from "./SurveyDownload.vue?vue&type=script&lang=js"
export * from "./SurveyDownload.vue?vue&type=script&lang=js"
import style0 from "./SurveyDownload.vue?vue&type=style&index=0&id=5913dd6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5913dd6e",
  null
  
)

export default component.exports